import {EDIT_LIVE_EVENT} from "../../../constants/LiveConstants";
import {EventLiveStoredObject} from "../../../@types/response";
import {GeneralAction} from "../../../@types/actions";

export const UpdateEventAction = (event: EventLiveStoredObject): GeneralAction<any> => ({
    type: EDIT_LIVE_EVENT,
    payload: {event}
});
